import styled from "styled-components";
import {AiOutlineMinus, AiOutlinePlus} from 'react-icons/ai'

export const MainContainer = styled.div`

  width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  user-select: none;

`;

export const Input = styled.input`
  height: 40px;
  width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 10px;
  border: none;
  border: 1px solid lightgray;
  outline: none;
  user-select: none;
`;

export const Plus = styled(AiOutlinePlus)`

  height: 20px;
  width: 20px;
  cursor: pointer;
  border: 1px solid lightgray;
  border-radius: 10px;
  padding: 3px;
  user-select: none;

`
export const Minus = styled(AiOutlineMinus)`

height: 20px;
  width: 20px;
  cursor: pointer;
  border: 1px solid lightgray;
  border-radius: 10px;
  padding: 3px;
  user-select: none;
`
